import { render } from "./CoverageRulesModal.vue?vue&type=template&id=7c6babd1&scoped=true"
import script from "./CoverageRulesModal.vue?vue&type=script&lang=js"
export * from "./CoverageRulesModal.vue?vue&type=script&lang=js"

import "./CoverageRulesModal.vue?vue&type=style&index=0&id=7c6babd1&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6babd1"]])

export default __exports__